import { render } from "./VideoUpload.vue?vue&type=template&id=d5563364&scoped=true"
import script from "./VideoUpload.vue?vue&type=script&lang=js"
export * from "./VideoUpload.vue?vue&type=script&lang=js"

import "./VideoUpload.vue?vue&type=style&index=0&id=d5563364&lang=scss"
import "./VideoUpload.vue?vue&type=style&index=1&id=d5563364&lang=scss&scoped=true"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5563364"]])

export default __exports__